<template lang="pug">
    .animation(ref='animation')
        .anim_playing-cards(v-if='name==="playingCards"', ref='playingCards')
            .anim_playing-cards-item(v-for='item in 4' :style='{zIndex: `${4 - item}`}')
                img(src='@/assets/img/articles/part-1/article-2/animations/card.png')
        .anim_ring(v-else-if='name==="ring"', ref='ring')
            svg.anim_ring-svg(width='100%' viewBox='0 0 216 326' preserveAspectRatio='xMidYMid meet')
                path(d='M156.84 120.246L143.829 135.22C175.08 149.058 196.95 180.409 196.95 216.789C196.95 265.929 157.049 305.917 108.005 305.917C58.9602 305.917 19.0501 265.939 19.0501 216.789C19.0501 180.419 40.9102 149.068 72.1619 135.23L59.1507 120.256C24.0508 138.121 0 174.635 0 216.789C0 276.552 48.3492 325.005 108.005 325.005C167.651 325.005 216 276.561 216 216.789C216 174.635 191.94 138.112 156.84 120.246Z' fill='black')
                path(d='M76.4767 61.3907L77.6006 63.1276L78.9532 61.572L98.9273 38.5814L101.175 35.9951H97.7557H62.8368H59.9697L61.5318 38.4097L76.4767 61.3907Z' fill='black')
                path(d='M68.6471 65.1603H71.5141L69.952 62.7553L55.4453 40.4423L54.169 38.4858L52.8545 40.4041L37.5858 62.7171L35.9189 65.1603H38.8717H68.6471Z' fill='black')
                path(d='M84.0684 65.1606H87.4879H128.512H131.932L129.693 62.5838L109.176 38.9729L107.995 37.6177L106.824 38.9729L86.3163 62.5838L84.0684 65.1606Z' fill='black')
                path(d='M137.037 61.572L138.399 63.1276L139.523 61.3907L154.468 38.4097L156.03 35.9951H153.163H118.244H114.815L117.063 38.5814L137.037 61.572Z' fill='black')
                path(d='M144.485 65.1603H147.352H177.128H180.081L178.414 62.7171L163.145 40.4041L161.83 38.4858L160.554 40.4423L146.047 62.7553L144.485 65.1603Z' fill='black')
                path(d='M134.408 71.3828H132.227H83.773H81.5918L82.3062 73.4538L106.528 144.134L107.995 148.428L109.472 144.134L133.694 73.4538L134.408 71.3828Z' fill='black')
                path(d='M75.0288 71.3828H36.8428L99.9083 143.905L75.0288 71.3828Z' fill='black')
                path(d='M140.971 71.3828H179.148L116.092 143.905L140.971 71.3828Z' fill='black')
                g.anim_ring-shine
                    mask#path-10-inside-1(fill='white')
                        path(d='M21.6846 30.6957L20 32.5957L32.1009 43L33.7855 41.1L21.6846 30.6957Z')
                    path(d='M21.6846 30.6957L20 32.5957L32.1009 43L33.7855 41.1L21.6846 30.6957Z' fill='black')
                    path(d='M20 32.5957L17.7252 30.6398L15.7349 32.8846L18.0098 34.8405L20 32.5957ZM21.6846 30.6957L23.6748 28.4508L21.4 26.495L19.4097 28.7398L21.6846 30.6957ZM33.7855 41.1L36.0603 43.0558L38.0506 40.811L35.7758 38.8551L33.7855 41.1ZM32.1009 43L30.1107 45.2448L32.3855 47.2007L34.3758 44.9559L32.1009 43ZM22.2748 34.5516L23.9594 32.6515L19.4097 28.7398L17.7252 30.6398L22.2748 34.5516ZM19.6943 32.9405L31.7953 43.3448L35.7758 38.8551L23.6748 28.4508L19.6943 32.9405ZM31.5107 39.1441L29.8261 41.0441L34.3758 44.9559L36.0603 43.0558L31.5107 39.1441ZM34.0912 40.7552L21.9902 30.3509L18.0098 34.8405L30.1107 45.2448L34.0912 40.7552Z' fill='black' mask='url(#path-10-inside-1)')
                g.anim_ring-shine
                    mask#path-12-inside-2(fill='white')
                        path(d='M58.7368 3.69943L56.3379 4.5835L61.2816 17.5927L63.6805 16.7086L58.7368 3.69943Z')
                    path(d='M58.7368 3.69943L56.3379 4.5835L61.2816 17.5927L63.6805 16.7086L58.7368 3.69943Z' fill='black')
                    path(d='M56.3379 4.5835L55.2722 1.77906L52.4571 2.81647L53.5229 5.62091L56.3379 4.5835ZM58.7368 3.69943L61.5518 2.66202L60.4861 -0.142413L57.6711 0.894997L58.7368 3.69943ZM63.6805 16.7086L64.7462 19.5131L67.5613 18.4756L66.4955 15.6712L63.6805 16.7086ZM61.2816 17.5927L58.4665 18.6301L59.5323 21.4345L62.3473 20.3971L61.2816 17.5927ZM57.4036 7.38793L59.8025 6.50387L57.6711 0.894997L55.2722 1.77906L57.4036 7.38793ZM55.9218 4.73684L60.8655 17.746L66.4955 15.6712L61.5518 2.66202L55.9218 4.73684ZM62.6148 13.9042L60.2158 14.7883L62.3473 20.3971L64.7462 19.5131L62.6148 13.9042ZM64.0966 16.5553L59.1529 3.54609L53.5229 5.62091L58.4665 18.6301L64.0966 16.5553Z' fill='black' mask='url(#path-12-inside-2)')
                g.anim_ring-shine
                    mask#path-18-inside-5(fill='white')
                        path(d='M109.372 0H106.811V13.1685H109.372V0Z')
                    path(d='M109.372 0H106.811V13.1685H109.372V0Z' fill='black')
                    path(d='M106.811 0V-3H103.811V0H106.811ZM109.372 0H112.372V-3H109.372V0ZM109.372 13.1685V16.1685H112.372V13.1685H109.372ZM106.811 13.1685H103.811V16.1685H106.811V13.1685ZM106.811 3H109.372V-3H106.811V3ZM106.372 0V13.1685H112.372V0H106.372ZM109.372 10.1685H106.811V16.1685H109.372V10.1685ZM109.811 13.1685V0H103.811V13.1685H109.811Z' fill='black' mask='url(#path-18-inside-5)')
                g.anim_ring-shine 
                    mask#path-16-inside-4(fill='white')
                        path(d='M154.701 3.69735L149.758 16.7065L152.157 17.5906L157.1 4.58142L154.701 3.69735Z')
                    path(d='M154.701 3.69735L149.758 16.7065L152.157 17.5906L157.1 4.58142L154.701 3.69735Z' fill='black')
                    path(d='M149.758 16.7065L146.943 15.6691L145.877 18.4736L148.692 19.511L149.758 16.7065ZM154.701 3.69735L155.767 0.892915L152.952 -0.144499L151.886 2.65994L154.701 3.69735ZM157.1 4.58142L159.915 5.61883L160.981 2.8144L158.166 1.77698L157.1 4.58142ZM152.157 17.5906L151.091 20.395L153.906 21.4325L154.972 18.628L152.157 17.5906ZM152.573 17.744L157.517 4.73477L151.886 2.65994L146.943 15.6691L152.573 17.744ZM153.636 6.50179L156.035 7.38585L158.166 1.77698L155.767 0.892915L153.636 6.50179ZM154.285 3.544L149.342 16.5532L154.972 18.628L159.915 5.61883L154.285 3.544ZM153.222 14.7862L150.824 13.9021L148.692 19.511L151.091 20.395L153.222 14.7862Z' fill='black' mask='url(#path-16-inside-4)')
                g.anim_ring-shine
                    mask#path-14-inside-3(fill='white')
                        path(d='M193.321 30.6972L181.22 41.1016L182.904 43.0016L195.005 32.5973L193.321 30.6972Z')
                    path(d='M193.321 30.6972L181.22 41.1016L182.904 43.0016L195.005 32.5973L193.321 30.6972Z' fill='black')
                    path(d='M181.22 41.1016L179.229 38.8567L176.955 40.8126L178.945 43.0574L181.22 41.1016ZM193.321 30.6972L195.595 28.7414L193.605 26.4966L191.33 28.4524L193.321 30.6972ZM195.005 32.5973L196.995 34.8421L199.27 32.8862L197.28 30.6414L195.005 32.5973ZM182.904 43.0016L180.629 44.9575L182.62 47.2023L184.895 45.2464L182.904 43.0016ZM183.21 43.3464L195.311 32.9421L191.33 28.4524L179.229 38.8567L183.21 43.3464ZM191.046 32.6531L192.73 34.5532L197.28 30.6414L195.595 28.7414L191.046 32.6531ZM193.015 30.3525L180.914 40.7568L184.895 45.2464L196.995 34.8421L193.015 30.3525ZM185.179 41.0457L183.495 39.1457L178.945 43.0574L180.629 44.9575L185.179 41.0457Z' fill='black' mask='url(#path-14-inside-3)')
                

        .anim_lattice(v-else-if='name==="lattice"', ref='lattice')
            img.anim_lattice-vert(src='@/assets/img/articles/part-1/article-4/animations/lattice-vert.png')
            .anim_lattice-hor
                img(src='@/assets/img/articles/part-1/article-4/animations/lattice-hor.png')
            .anim_lattice-lock
                img.anim_lattice-lock-body(src='@/assets/img/articles/part-1/article-4/animations/lattice-lock.png')
                .anim_lattice-lock-hand
                    img(src='@/assets/img/articles/part-1/article-4/animations/lattice-lock-hand.png')
        .anim_female(v-else-if='name==="female"', ref='female')
            svg(width='100%' viewBox='0 0 288 245' preserveAspectRatio='xMidYMid meet')
                path(d='M184.612 51.9529C184.612 51.9529 189.46 77.7177 204.758 88.7831C204.758 88.7831 209.05 91.2106 198.663 98.8659C198.663 98.8659 199.954 103.206 202.158 106.628C204.361 110.051 191.617 116.324 190.207 123.192C188.798 130.06 187.588 137.455 195.125 143.697C195.125 143.697 197.888 146.573 191.973 150.61C191.998 150.592 192.931 157.033 192.87 157.638C191.856 167.7 181.285 164.108 174.535 163.395C165.616 162.455 155.406 161.426 146.751 164.378L124.708 190.407L165.795 244.092H17.0742H0.00012207L35.9549 186.325C35.9549 186.325 40.3411 177.93 54.4788 173.846L72.0042 168.775L84.0569 153.02L81.6822 70.6848L131.642 31.7104L184.612 51.9529Z' fill='var(--color-first)')
                path(d='M88.8611 164.721C88.8611 156.03 66.26 169.923 45.019 156.441C12.3925 135.731 12.1829 79.5405 35.1217 43.1616C47.7313 23.1623 73.3392 -7.17579 127.095 1.53408C130.668 2.11335 140.146 5.23053 143.089 8.89178C163.321 4.39363 194.312 25.0122 194.312 64.2682C191.664 61.9767 189.131 60.0085 186.659 58.3267' fill='var(--color-first)')
                g(transform='translate(0 0)')
                    g.anim_female-scream
                        path(d='M206.983 122.232L279.346 86.7817L283.172 95.5396L206.983 122.232Z' fill='var(--color-first)')
                        path(d='M206.752 128.931L287.08 125.548V134.317L206.752 128.931Z' fill='var(--color-first)')
                        path(d='M205.939 135.022L281.221 164.722L277.615 172.727L205.939 135.022Z' fill='var(--color-first)')
        .anim_tunes(v-else-if='name==="tunes"', ref='tunes')
            svg(width='100%' viewBox='0 0 288 120' preserveAspectRatio='xMidYMid meet')
                g.anim_tunes-note
                    path(d='M67.2233 34.4585L20.2826 46.1249V102.695C17.22 100.86 12.5075 101.274 8.52652 104.036C3.53687 107.499 1.58978 113.328 4.18479 117.054C6.77981 120.78 12.925 120.997 17.9147 117.538C21.8022 114.842 23.8294 110.715 23.3184 107.256L23.4053 48.3134L64.1039 38.3251V91.8396C61.0414 90.0048 56.3289 90.4185 52.3479 93.1808C47.3582 96.6436 45.4145 102.472 48.0062 106.198C50.5978 109.925 56.7464 110.142 61.736 106.682C65.6235 103.986 67.6508 99.8563 67.1398 96.4001L67.2233 37.441V34.4585Z' fill='black')
                g.anim_tunes-note
                    path(d='M108.8 0.00333611L105.717 0L105.68 55.7998C102.661 53.9883 98.0121 54.392 94.0845 57.1143C89.1583 60.5271 87.238 66.2752 89.7929 69.955C92.3478 73.6347 98.4096 73.8515 103.336 70.4387C107.17 67.7831 109.174 63.7131 108.669 60.3036L108.8 0.00333611Z' fill='black')
                g.anim_tunes-note
                    path(d='M206.206 5.60498L159.265 17.2747V73.8452C156.202 72.0103 151.49 72.424 147.509 75.1863C142.519 78.6492 140.572 84.4774 143.167 88.2038C145.762 91.9302 151.907 92.1471 156.897 88.6875C160.785 85.992 162.812 81.8652 162.301 78.4056L162.388 19.4632L203.086 9.47487V62.9895C200.024 61.1546 195.311 61.5683 191.33 64.3306C186.341 67.7935 184.397 73.6217 186.989 77.3481C189.58 81.0745 195.729 81.2914 200.718 77.8318C204.606 75.1363 206.633 71.0061 206.122 67.5499L206.206 8.5908V5.60498Z' fill='black')
                g.anim_tunes-note
                    path(d='M247.301 91.3729L250.383 91.3762L250.42 35.5764C253.439 37.3879 258.088 36.9842 262.016 34.262C266.942 30.8491 268.862 25.101 266.308 21.4213C263.753 17.7415 257.688 17.5247 252.765 20.9375C248.927 23.5931 246.927 27.6631 247.431 31.0726L247.301 91.3729Z' fill='black')
                path(d='M288 27.3462H0V29.3245H288V27.3462Z' fill='black')
                path(d='M288 44.6538H0V46.6321H288V44.6538Z' fill='black')
                path(d='M288 61.9648H0V63.9432H288V61.9648Z' fill='black')
                path(d='M288 79.2729H0V81.2513H288V79.2729Z' fill='black')
                path(d='M288 96.584H0V98.5623H288V96.584Z' fill='black')
        .anim_bricks(v-else-if='name==="bricks"', ref='bricks')
            svg(width='100%' viewBox='0 0 344 202' preserveAspectRatio='xMidYMid meet')
                g.anim_bricks-row
                    rect.anim_brick(y='0.5' width='96' height='37' fill='black')
                    rect.anim_brick(x='100' y='0.5' width='96' height='37' fill='black')
                    rect.anim_brick(x='200' y='0.5' width='96' height='37' fill='black')
                g.anim_bricks-row
                    rect.anim_brick(x='48' y='41.5' width='96' height='37' fill='black')
                    rect.anim_brick(x='148' y='41.5' width='96' height='37' fill='black')
                    rect.anim_brick(x='248' y='41.5' width='96' height='37' fill='black')
                g.anim_bricks-row
                    rect.anim_brick(y='82.5' width='96' height='37' fill='black')
                    rect.anim_brick(x='100' y='82.5' width='96' height='37' fill='black')
                    rect.anim_brick(x='200' y='82.5' width='96' height='37' fill='black')
                g.anim_bricks-row
                    rect.anim_brick(x='148' y='123.5' width='96' height='37' fill='black')
                    rect.anim_brick(x='248' y='123.5' width='96' height='37' fill='black')
                    rect.anim_brick(x='48' y='123.5' width='96' height='37' fill='black')
                g.anim_bricks-row
                    rect.anim_brick(y='164.5' width='96' height='37' fill='black')
                    rect.anim_brick(x='100' y='164.5' width='96' height='37' fill='black')
                    rect.anim_brick(x='200' y='164.5' width='96' height='37' fill='black')
                    
                



        .default(v-else ref='default')
            span Анимация  
</template>
<script>
import {lib} from '../../assets/js/animation/animations';
import {mixinAnimation} from '../mixins/mixinAnimation';

export default {
    mixins: [mixinAnimation],
    data() {
        return {
            lib
        };
    },
    props: {
        name: {
            type: String,
            default: 'default'
        },
        isActive: {
            type: Boolean,
            default: false
        }
    },
    methods: {
        createAnimation() {
            this.timeline = this.lib[this.name]
                ? this.lib[this.name].createTimeline(this.$refs[this.name])
                : this.lib['default'].createTimeline(this.$refs['default']);
            this.timeline.progress(0.0001);
            this.timeline.pause();
            this.lib[this.name] ? this.createScroll(...this.lib[this.name].fromTo) : this.createScroll(...this.lib['default'].fromTo);
        }
    }
};
</script>
<style lang="scss">
.animation {
    img {
        display: block;
        width: 100%;
        height: auto;
    }
}
.anim {
    &_playing-cards {
        overflow: hidden;
        &-item {
            position: relative;
            &:not(:last-child) {
                margin-bottom: -30%;
                @media (--viewport-tablet) {
                    margin-bottom: -50%;
                }
            }
        }
    }
    &_ring {
        padding-left: var(--grid-column);
        &-svg {
            max-height: 290px;
        }
        @media (--viewport-tablet) {
            padding-left: 0;
            padding-bottom: 30px;
            margin: auto;
        }
    }
    &_female {
        @media (--viewport-tablet) {
            margin-bottom: 15px;
        }
    }
    &_tunes {
        @media (--viewport-tablet) {
            padding-top: 20px;
        }
    }
    &_lattice {
        position: relative;
        &-hor {
            position: absolute;
            width: 100%;
            top: 0;
            left: 0;
        }
        &-lock {
            position: absolute;
            width: 100%;
            top: 0;
            left: 0;
            &-hand {
                position: absolute;
                width: 100%;
                top: 0;
                left: 0;
            }
        }
    }
    &_bricks {
        @media (--viewport-tablet) {
            margin-top: 15px;
        }
    }
}
</style>
